var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var toEstree = require('hast-util-to-estree');

var walk = require('estree-walker').walk;

var periscopic = require('periscopic');

var estreeToJs = require('./estree-to-js');

function serializeEstree(estree, options) {
  var _options$skipExport = options.skipExport,
      skipExport = _options$skipExport === void 0 ? false : _options$skipExport,
      wrapExport = options.wrapExport;
  var layout;
  var children = [];
  var mdxLayoutDefault; // Find the `export default`, the JSX expression, and leave the rest
  // (import/exports) as they are.

  estree.body = estree.body.filter(function (child) {
    // ```js
    // export default a = 1
    // ```
    if (child.type === 'ExportDefaultDeclaration') {
      layout = child.declaration;
      return false;
    } // ```js
    // export {default} from "a"
    // export {default as a} from "b"
    // export {default as a, b} from "c"
    // export {a as default} from "b"
    // export {a as default, b} from "c"
    // ```


    if (child.type === 'ExportNamedDeclaration' && child.source) {
      // Remove `default` or `as default`, but not `default as`, specifier.
      child.specifiers = child.specifiers.filter(function (specifier) {
        if (specifier.exported.name === 'default') {
          mdxLayoutDefault = {
            local: specifier.local,
            source: child.source
          };
          return false;
        }

        return true;
      }); // Keep the export if there are other specifiers, drop it if there was
      // just a default.

      return child.specifiers.length > 0;
    }

    if (child.type === 'ExpressionStatement' && (child.expression.type === 'JSXFragment' || child.expression.type === 'JSXElement')) {
      children = child.expression.type === 'JSXFragment' ? child.expression.children : [child.expression];
      return false;
    }

    return true;
  }); // Find everything that’s defined in the top-level scope.
  // Do this here because `estree` currently only includes import/exports
  // and we don’t have to walk all the JSX to figure out the top scope.

  var inTopScope = ['MDXLayout', 'MDXContent'].concat(_toConsumableArray(periscopic.analyze(estree).scope.declarations.keys()));
  estree.body = [].concat(_toConsumableArray(estree.body), _toConsumableArray(createMdxLayout(layout, mdxLayoutDefault)), _toConsumableArray(createMdxContent(children))); // Add `mdxType`, `parentName` props to JSX elements.

  var magicShortcodes = [];
  var stack = [];
  walk(estree, {
    enter: function enter(node) {
      if (node.type === 'JSXElement' && // To do: support members (`<x.y>`).
      node.openingElement.name.type === 'JSXIdentifier') {
        var name = node.openingElement.name.name;

        if (stack.length > 1) {
          var parentName = stack[stack.length - 1];
          node.openingElement.attributes.push({
            type: 'JSXAttribute',
            name: {
              type: 'JSXIdentifier',
              name: 'parentName'
            },
            value: {
              type: 'Literal',
              value: parentName,
              raw: JSON.stringify(parentName)
            }
          });
        }

        var head = name.charAt(0); // A component.

        if (head === head.toUpperCase() && name !== 'MDXLayout') {
          node.openingElement.attributes.push({
            type: 'JSXAttribute',
            name: {
              type: 'JSXIdentifier',
              name: 'mdxType'
            },
            value: {
              type: 'Literal',
              value: name,
              raw: JSON.stringify(name)
            }
          });

          if (!inTopScope.includes(name) && !magicShortcodes.includes(name)) {
            magicShortcodes.push(name);
          }
        }

        stack.push(name);
      }
    },
    leave: function leave(node) {
      if (node.type === 'JSXElement' && // To do: support members (`<x.y>`).
      node.openingElement.name.type === 'JSXIdentifier') {
        stack.pop();
      }
    }
  });
  var exports = [];

  if (!skipExport) {
    var declaration = {
      type: 'Identifier',
      name: 'MDXContent'
    };

    if (wrapExport) {
      declaration = {
        type: 'CallExpression',
        callee: {
          type: 'Identifier',
          name: wrapExport
        },
        arguments: [declaration]
      };
    }

    exports.push({
      type: 'ExportDefaultDeclaration',
      declaration: declaration
    });
  }

  estree.body = [].concat(_toConsumableArray(createMakeShortcodeHelper(magicShortcodes, options.mdxFragment === false)), _toConsumableArray(estree.body), exports);
  return estreeToJs(estree);
}

function compile() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  function compiler(tree, file) {
    return serializeEstree(toEstree(tree), _objectSpread({
      filename: file.path
    }, options));
  }

  this.Compiler = compiler;
}

module.exports = compile;
compile.default = compile;

function createMdxContent(children) {
  return [{
    type: 'FunctionDeclaration',
    id: {
      type: 'Identifier',
      name: 'MDXContent'
    },
    expression: false,
    generator: false,
    async: false,
    params: [{
      type: 'ObjectPattern',
      properties: [{
        type: 'Property',
        method: false,
        shorthand: true,
        computed: false,
        key: {
          type: 'Identifier',
          name: 'components'
        },
        kind: 'init',
        value: {
          type: 'Identifier',
          name: 'components'
        }
      }, {
        type: 'RestElement',
        argument: {
          type: 'Identifier',
          name: 'props'
        }
      }]
    }],
    body: {
      type: 'BlockStatement',
      body: [{
        type: 'ReturnStatement',
        argument: {
          type: 'JSXElement',
          openingElement: {
            type: 'JSXOpeningElement',
            attributes: [{
              type: 'JSXAttribute',
              name: {
                type: 'JSXIdentifier',
                name: 'components'
              },
              value: {
                type: 'JSXExpressionContainer',
                expression: {
                  type: 'Identifier',
                  name: 'components'
                }
              }
            }, {
              type: 'JSXSpreadAttribute',
              argument: {
                type: 'Identifier',
                name: 'props'
              }
            }],
            name: {
              type: 'JSXIdentifier',
              name: 'MDXLayout'
            },
            selfClosing: false
          },
          closingElement: {
            type: 'JSXClosingElement',
            name: {
              type: 'JSXIdentifier',
              name: 'MDXLayout'
            }
          },
          children: children
        }
      }]
    }
  }, {
    type: 'ExpressionStatement',
    expression: {
      type: 'AssignmentExpression',
      operator: '=',
      left: {
        type: 'MemberExpression',
        object: {
          type: 'Identifier',
          name: 'MDXContent'
        },
        property: {
          type: 'Identifier',
          name: 'isMDXComponent'
        },
        computed: false,
        optional: false
      },
      right: {
        type: 'Literal',
        value: true,
        raw: 'true'
      }
    }
  }];
}

function createMdxLayout(declaration, mdxLayoutDefault) {
  var id = {
    type: 'Identifier',
    name: 'MDXLayout'
  };
  var init = {
    type: 'Literal',
    value: 'wrapper',
    raw: '"wrapper"'
  };
  return [mdxLayoutDefault ? {
    type: 'ImportDeclaration',
    specifiers: [mdxLayoutDefault.local.name === 'default' ? {
      type: 'ImportDefaultSpecifier',
      local: id
    } : {
      type: 'ImportSpecifier',
      imported: mdxLayoutDefault.local,
      local: id
    }],
    source: {
      type: 'Literal',
      value: mdxLayoutDefault.source.value,
      raw: mdxLayoutDefault.source.raw
    }
  } : {
    type: 'VariableDeclaration',
    declarations: [{
      type: 'VariableDeclarator',
      id: id,
      init: declaration || init
    }],
    kind: 'const'
  }];
}

function createMakeShortcodeHelper(names, useElement) {
  var func = {
    type: 'VariableDeclaration',
    declarations: [{
      type: 'VariableDeclarator',
      id: {
        type: 'Identifier',
        name: 'makeShortcode'
      },
      init: {
        type: 'ArrowFunctionExpression',
        id: null,
        expression: true,
        generator: false,
        async: false,
        params: [{
          type: 'Identifier',
          name: 'name'
        }],
        body: {
          type: 'ArrowFunctionExpression',
          id: null,
          expression: false,
          generator: false,
          async: false,
          params: [{
            type: 'Identifier',
            name: 'props'
          }],
          body: {
            type: 'BlockStatement',
            body: [{
              type: 'ExpressionStatement',
              expression: {
                type: 'CallExpression',
                callee: {
                  type: 'MemberExpression',
                  object: {
                    type: 'Identifier',
                    name: 'console'
                  },
                  property: {
                    type: 'Identifier',
                    name: 'warn'
                  },
                  computed: false,
                  optional: false
                },
                arguments: [{
                  type: 'Literal',
                  value: 'Component `%s` was not imported, exported, or provided by MDXProvider as global scope'
                }, {
                  type: 'Identifier',
                  name: 'name'
                }]
              }
            }, {
              type: 'ReturnStatement',
              argument: useElement ? {
                type: 'JSXElement',
                openingElement: {
                  type: 'JSXOpeningElement',
                  attributes: [{
                    type: 'JSXSpreadAttribute',
                    argument: {
                      type: 'Identifier',
                      name: 'props'
                    }
                  }],
                  name: {
                    type: 'JSXIdentifier',
                    name: 'div'
                  },
                  selfClosing: true
                },
                closingElement: null,
                children: []
              } : {
                type: 'JSXFragment',
                openingFragment: {
                  type: 'JSXOpeningFragment'
                },
                closingFragment: {
                  type: 'JSXClosingFragment'
                },
                children: [{
                  type: 'JSXExpressionContainer',
                  expression: {
                    type: 'MemberExpression',
                    object: {
                      type: 'Identifier',
                      name: 'props'
                    },
                    property: {
                      type: 'Identifier',
                      name: 'children'
                    },
                    computed: false
                  }
                }]
              }
            }]
          }
        }
      }
    }],
    kind: 'const'
  };
  var shortcodes = names.map(function (name) {
    return {
      type: 'VariableDeclaration',
      declarations: [{
        type: 'VariableDeclarator',
        id: {
          type: 'Identifier',
          name: String(name)
        },
        init: {
          type: 'CallExpression',
          callee: {
            type: 'Identifier',
            name: 'makeShortcode'
          },
          arguments: [{
            type: 'Literal',
            value: String(name)
          }]
        }
      }],
      kind: 'const'
    };
  });
  return shortcodes.length > 0 ? [func].concat(_toConsumableArray(shortcodes)) : [];
}